<template>
  <FormContainer without-divider>
    <template #content>
      <div class="form__bloc">
        <WrapperToggleSwitch
          id="field_206"
          v-model="attestationResteChargeContributionModel"
          label="En cas de reste à charge sur votre dossier, souhaitez-vous qu’il soit pris en charge ? "
          :required="meta.financement?.attestationResteChargeContribution?.$status === PropertyStatus.Required"
          :alertLabel="meta.financement?.attestationResteChargeContribution?.$messageErreurDirty!"
          :items="OuiOuNon"
          :readonly
          nbMaxLines="2"
          class="col-12 col-md-18 col-sm-36"
        />
        <WrapperDropdown
          v-if="meta.financement?.modePriseEnChargeReste?.$status !== PropertyStatus.NotPresent"
          id="field_207"
          v-model="modePriseEnChargeResteModel"
          label="Le reste à charge doit être pris sur votre contribution :"
          :required="meta.financement?.modePriseEnChargeReste?.$status === PropertyStatus.Required"
          :alertLabel="meta.financement?.modePriseEnChargeReste?.$messageErreurDirty!"
          class="col-12 col-md-18 col-sm-36"
          :items="resteChargeContribution"
          :readonly
        />
        <WrapperDropdown
          v-else
          id="field_207"
          label="Le reste à charge doit être pris sur votre contribution :"
          class="col-12 col-md-18 col-sm-36"
          disabled
        />
      </div>
    </template>
  </FormContainer>
  <FormContainer>
    <template #title>Référence</template>
    <template #content>
      <div class="form__bloc">
        <WrapperInput
          id="field_160"
          v-model="referenceFormationInterneEntrepriseModel"
          label="Référence interne de l'entreprise"
          :required="meta.reference?.$status === PropertyStatus.Required"
          :alertLabel="meta.reference?.$messageErreurDirty!"
          class="col-12 col-md-18 col-sm-36"
          hint="30 caractères maximum"
          help="Ce champ vous permet de renseigner une référence propre à votre entreprise"
          :maxlength="30"
          deletable
          :readonly
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
import {
  ResteChargeContributionTypePublicInterimaire,
  ResteChargeContributionTypePublicInterimaireCDI,
  ResteChargeContributionTypePublicPermanent,
} from '@/features/domaine/types/opco/Demande/DR/ResteChargeContribution'
import { ResteChargeContributionLibelle } from '@/features/domaine/types/opco/Demande/shared/ResteChargeContribution'
import { arrayToDropdownItems, OuiOuNon } from '@/features/interface/shared/tools'
import type { DropdownItem } from '@designSystem/index'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import FormContainer from '../../../shared/components/FormContainer.vue'
import { useDemandeDRStore } from '../../useDRStore'

  const store = useDemandeDRStore()
  const { setupFieldWithKey } = store
  const { readonly, meta, model } = storeToRefs(store)

  const attestationResteChargeContributionModel = setupFieldWithKey<boolean>('financement.attestationResteChargeContribution')
  const modePriseEnChargeResteModel = setupFieldWithKey<string | null>('financement.modePriseEnChargeReste')
  const referenceFormationInterneEntrepriseModel = setupFieldWithKey<string>('reference', true,)

  const resteChargeContribution = computed<DropdownItem<string>[]>(() => {
    if (model.value?.typePublic === 'Permanent') {
      return arrayToDropdownItems(ResteChargeContributionTypePublicPermanent, ResteChargeContributionLibelle)
    } else if (model.value?.typePublic === 'Interimaire') {
      const base = model.value?.stagiaires?.some((s) => s.natureContrat === 'TravailTemporaireCdi')
          ? ResteChargeContributionTypePublicInterimaireCDI
          : ResteChargeContributionTypePublicInterimaire

      return arrayToDropdownItems(base, ResteChargeContributionLibelle)
    } else {
      return []
    }
  })
</script>
<style lang="less">
  :deep(.input-label) {
    background-color: red;
    flex-shrink: 0 !important;
  }
</style>
